import { o_global } from "@gr-common/head/namespaces";
import { GlobalStorage, globalStorage } from "./storage";

/*                                              */
o_global.Storage ||= GlobalStorage;
o_global.globalStorage ||= globalStorage;
